import { render, staticRenderFns } from "./SearchPrivacyAgree.vue?vue&type=template&id=55a41fb1"
import script from "./SearchPrivacyAgree.vue?vue&type=script&lang=js"
export * from "./SearchPrivacyAgree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports